var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkTimelineicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:timeline-text-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.08696 8C4.08696 8.666 3.62261 9.2 3.04348 9.2C2.8371 9.2 2.63535 9.12962 2.46375 8.99776C2.29215 8.86591 2.15841 8.67849 2.07943 8.45922C2.00045 8.23995 1.97979 7.99867 2.02005 7.76589C2.06031 7.53311 2.1597 7.3193 2.30563 7.15147C2.45156 6.98365 2.63749 6.86936 2.83991 6.82306C3.04232 6.77676 3.25213 6.80052 3.4428 6.89134C3.63347 6.98217 3.79644 7.13598 3.9111 7.33332C4.02576 7.53065 4.08696 7.76266 4.08696 8ZM3.56522 2V5.6H2.52174V2H3.56522ZM2.52174 14V10.4H3.56522V14H2.52174ZM14 4.4V11.6C14 12.266 13.5357 12.8 12.9565 12.8H6.69565C6.4189 12.8 6.15349 12.6736 5.9578 12.4485C5.76211 12.2235 5.65217 11.9183 5.65217 11.6V9.2L4.6087 8L5.65217 6.8V4.4C5.65217 4.08174 5.76211 3.77652 5.9578 3.55147C6.15349 3.32643 6.4189 3.2 6.69565 3.2H12.9565C13.5357 3.2 14 3.734 14 4.4ZM12.9565 4.4H6.69565V7.298L6.08522 8L6.69565 8.702V11.6H12.9565V4.4ZM7.73913 6.2H11.913V7.4H7.73913V6.2ZM7.73913 8.6H10.8696V9.8H7.73913V8.6Z",
    fill: "#6C757D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkTimelineicon);
export default __webpack_public_path__ + "static/media/sk-timelineicon.dd8519209fa6c206a466ce9f834aaa9b.svg";
export { ForwardRef as ReactComponent };